module.exports = __webpack_public_path__ + "static/media/tutorial-card-2.4c07ebb4.png";